import { FC, useEffect, useState } from "react";
import axios from "axios";
import { URL } from '../../../redux/common/url';
import { toast } from "react-toastify";
import { handleCopy, handleCSV, handleCSVNew, handleExcel, handleExcelNew, handlePDF, handlePDFNew } from './print';
import moment from 'moment';
import ReactPaginate from "react-paginate";
import { AsyncPaginate } from "react-select-async-paginate";
import { revenueReportColumns } from "../../constant";

interface Value {
  id: string;
  name: string;
};

interface Option {
  value: string
  label: string
};

interface PaginatedResponse {
  results: Option[]
  has_more: boolean
};

const Revenue: FC = () => {
  const [vendor, setVendor] = useState<any[]>([]);
  const [vehicle, setVehicle] = useState<any[]>([]);
  const [circles, setCircles] = useState<Value[]>([]);
  const [reportData, setReportData] = useState([]);
  const [page, setPage] = useState<number>(1);
  const [vendorId, setVendorId] = useState<string>('');
  const [fromDate, setFromDate] = useState<string>('');
  const [toDate, setToDate] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [circleId, setCircleId] = useState('')
  
  // XEN / AEN / JEN filters
  const [seleceteMangerXenForFilters, setseleceteMangerXenForFilters] = useState<any>({})
  const [seleceteMangerAenForFilters, setseleceteMangerAenForFilters] = useState<any>({})
  const [seleceteMangerJenForFilters, setseleceteMangerJenForFilters] = useState<any>({})

  const [managerKey, setManagerKey] = useState(0)
  const [managerKeyAen, setManagerKeyAen] = useState(0)
  const [managerKeyJen, setManagerKeyJen] = useState(0)


  const [seleceteSource, setseleceteSource] = useState<any>({});
  const [pageNo, setpageNo] = useState<any>(1);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    fetchCircles();
    getReports();
  }, [pageNo]);

  const handlePageClick = (event: any) => {
    // const newOffset = event.selected % (comments.length / 2);
    // setCurrentPage(newOffset + 1);
    // setItemOffset(newOffset * itemsPerPage);

    const data = event?.selected + 1

    setpageNo(data)

    // if (!userSearch) {
    // dispatch(adminAction.getCurrentBookings(data))

    return () => { }
    // } else {
    //   dispatch(
    //     ShoetoggelAction.searchUser({ pageNumber: data, key: userSearch })
    //   );

    //   return () => {};
    // }
  };

  const user = JSON.parse(localStorage.getItem('access_admin_token')!).data;

  const handleVendor = async (vData: any) => {
    setVendor(vData);
    setVendorId(vData?.id);
  };

  const fetchCircles = async () => {
    try {
      const response = await axios.get(`${URL.API_BASE_URL + URL.getAllCircles}`);
      if (response?.data?.data) {
        setCircles(response?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeCircle = async (circleId: string) => {
    // try {
    // setVendorId(circleId);
    setCircleId(circleId)
    setseleceteMangerXenForFilters({})
    setseleceteMangerAenForFilters({})
    setseleceteMangerJenForFilters({})

    setManagerKey(k => k + 1)
    setManagerKeyAen(k => k + 1)
    setManagerKeyJen(k => k + 1)

    setVendorId('')
    setpageNo(1)
    // const res = await axios.get(`${URL.API_BASE_URL}${URL.getVendorList}?circle_id=${circleId}`);
    // if (res?.data?.results) {
    //   setVendor(res?.data?.results);
    // }
    // } catch (error) {
    //   console.error(error);
    // }
  };

  const getReports = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("kt-auth-react-v")!);
      const config = {
        headers: {
          Authorization: "Bearer " + token.api_token,
        },
      };

      const query = [
        `approved=pending`,
        `page=${pageNo}`,
        seleceteMangerXenForFilters?.id && `xen_id=${seleceteMangerXenForFilters.id}`,
        seleceteMangerAenForFilters?.id && `aen_id=${seleceteMangerAenForFilters.id}`,
        seleceteMangerJenForFilters?.id && `jen_id=${seleceteMangerJenForFilters.id}`,
        vendorId && `vendor=${vendorId}`,
        // vehicleId && `vehicle_id=${vehicleId}`,
        fromDate && `fromdate=${moment(fromDate).format('YYYY-MM-DD')}`,
        toDate && `todate=${moment(toDate).format('YYYY-MM-DD')}`,
        name && `search=${name}`,
      ].filter(Boolean).join('&');

      const res = await axios.get(`${URL.API_BASE_URL}/api/admins/revenueVendorwise?${query}`, config);


      if (res?.data?.data?.data) {
        setReportData(res?.data?.data?.data);
        // setPage(res?.data?.current_page);
        // setPage(res?.data?.data?.current_page)
        setPageCount(Math.ceil(res?.data?.data?.total / 50))
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };


  const loadOptionsgetManagerXenForFilters = async (search: any, loaded: any, { page }: any) => {
    if (!circleId) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const res = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${circleId}`,
      {
        headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
      }
    )

    const json = await res.json()

    return {
      options: json?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: json.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerAenForFilters = async (search: any, loaded: any, { page }: any) => {
    if (!seleceteMangerXenForFilters?.id) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const res = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerXenForFilters.id}&circle_id=${circleId}`,
      {
        headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
      }
    )

    const json = await res.json()

    return {
      options: json?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: json.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerJenForFilters = async (search: any, loaded: any, { page }: any) => {
    if (!seleceteMangerAenForFilters?.id) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const res = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerAenForFilters.id}&circle_id=${circleId}`,
      {
        headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
      }
    )

    const json = await res.json()

    return {
      options: json?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: json.has_more,
      additional: { page: page + 1 },
    }
  }


  const loadOptionsgetSource = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v')
    let url = `${URL.API_BASE_URL}${URL.getVendorList}?circle_id=${circleId}&page=${page}&search=${search}`

    if (seleceteMangerJenForFilters?.id) {
      url += `&jen_id=${seleceteMangerJenForFilters.id}`
    }

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token).api_token}`,
      },
    });

    const responseJSON: PaginatedResponse = await response.json()
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.id;
      data.label = data?.name;
      return data;
    });
    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    }
  };

  const handleDownload = async () => {
    try {
      const token: any = await localStorage.getItem('kt-auth-react-v')
      const config = {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token).api_token,
        },
      }
      const query = [
        `approved=pending`,
        seleceteMangerXenForFilters?.id && `xen_id=${seleceteMangerXenForFilters.id}`,
        seleceteMangerAenForFilters?.id && `aen_id=${seleceteMangerAenForFilters.id}`,
        seleceteMangerJenForFilters?.id && `jen_id=${seleceteMangerJenForFilters.id}`,
        vendorId && `vendor=${vendorId}`,
        // vehicleId && `vehicle_id=${vehicleId}`,
        fromDate && `fromdate=${moment(fromDate).format('YYYY-MM-DD')}`,
        toDate && `todate=${moment(toDate).format('YYYY-MM-DD')}`,
        name && `search=${name}`,
      ].filter(Boolean).join('&');

      const res = await axios.get(
        `${URL.API_BASE_URL}${URL.downloadVendorwise}?${query}`,
        config
      )
      console.log(res)
      console.log(res?.data?.data)
      if (res?.data?.data) {
        return res?.data?.data;
      };
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    };
  };

  return (
    <div>
      <div className="d-flex justify-content-between">
        <h3 className="text-gray-600">Revenue Report</h3>
        <p><span className="text-primary">Home</span> / Revenue Report</p>
      </div>
      <div className="bg-transparent shadow m-0 p-3 pt-6 rounded-2xl">
        <div className="row g-3 align-items-end px-5">

          {/* Circle */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Circle</label>
            <select
              className="form-control"
              name="circle_id"
              onChange={(e: any) => handleChangeCircle(e.target.value)}
            >
              <option value="">Select Circle</option>
              {circles.map((data, i) => (
                <option value={data.id} key={i}>
                  {data.name}
                </option>
              ))}
            </select>
          </div>

          {/* XEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select XEN</label>
            <AsyncPaginate
              key={managerKey}
              value={seleceteMangerXenForFilters}
              loadOptions={loadOptionsgetManagerXenForFilters}
              onChange={(e: any) => {
                setseleceteMangerXenForFilters(e)
                setseleceteMangerAenForFilters({})
                setseleceteMangerJenForFilters({})
                setManagerKeyAen(k => k + 1)
                setManagerKeyJen(k => k + 1)
                setVendorId('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* AEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select AEN</label>
            <AsyncPaginate
              key={managerKeyAen}
              value={seleceteMangerAenForFilters}
              loadOptions={loadOptionsgetManagerAenForFilters}
              onChange={(e: any) => {
                setseleceteMangerAenForFilters(e)
                setseleceteMangerJenForFilters({})
                setManagerKeyJen(k => k + 1)
                setVendorId('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* JEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select JEN</label>
            <AsyncPaginate
              key={managerKeyJen}
              value={seleceteMangerJenForFilters}
              loadOptions={loadOptionsgetManagerJenForFilters}
              onChange={(e: any) => {
                setseleceteMangerJenForFilters(e)
                setVendorId('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Vendor */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Vendor</label>
            <AsyncPaginate
              key={`${circleId}-${seleceteMangerJenForFilters?.id || 'no-jen'}`}
              loadOptions={loadOptionsgetSource}
              onChange={(item: any) => handleVendor(item)}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Date From */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Date From</label>
            <input
              type="date"
              className="form-control"
              onChange={(e: any) => setFromDate(e.target.value)}
            />
          </div>

          {/* Date To */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Date To</label>
            <input
              type="date"
              className="form-control"
              onChange={(e: any) => setToDate(e.target.value)}
            />
          </div>

          {/* View Button */}
          <div className="col-md-2">
            <button
              className="btn w-100 text-white"
              style={{ backgroundColor: "#52A841" }}
              onClick={() => getReports()}
            >
              View
            </button>
          </div>
        </div>
        {/* Copy CSV PDF EXCEL Search */}
        <div className="d-flex align-items-center justify-content-between gap-4 mt-4 px-5">
          <div className="d-flex gap-1">
            {/* <div className="p-2" style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();
                if (!data || !Array.isArray(data)) {
                  alert("No data available to copy");
                  return;
                }
                handleCopy(data);
              }}
            >Copy</div > */}
            <div className="p-2" style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();

                handleCSVNew(data, revenueReportColumns, "Report Revenue Wise", fromDate, toDate)
              }}
            >CSV</div>
            <div className="p-2" style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();

                handlePDFNew(data, revenueReportColumns, "Report Revenue Wise", fromDate, toDate)
              }}
            >PDF</div>
            <div className="p-2" style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();

                handleExcelNew(data, revenueReportColumns, "Report Revenue Wise", fromDate, toDate)
              }}
            >EXCEL</div>
          </div>
          <div>
            <input type="search" placeholder="Search by Name" className="form-control" onChange={(e: any) => setName(e.target.value)} />
          </div>
        </div>

        {/* Revenue Table */}
        <div className="mt-9">
          <table className="table" style={{ 'fontSize': '12px', 'fontWeight': '300' }}>
            <thead className="table-light">
              <tr>
                <th>S.NO.</th>
                <th>Vendor</th>
                <th>Tanker Number</th>
                <th>Total Trip</th>
                <th>Distance</th>
              </tr>
            </thead>
            <tbody style={{ 'maxHeight': '60vh', 'overflow': 'auto' }} >
              {
                reportData.length > 0 && reportData.map((item: any, index: any) => {

                  return (
                    <tr key={index}>
                      <td> {(pageNo - 1) * 50 + index + 1} </td>
                      <td>{item?.name || "--"}</td>
                      <td>{item?.tankers_number}</td>
                      <td>{item?.bookings_count}</td>
                      {/* <td>{item?.bookings_sum_total_distance}</td> */}
                      <td>{item?.total_distance?.toFixed(2)}</td>
                    </tr>
                  )
                })
              }
            </tbody >

            <tfoot>
              <tr>

                <td><b>Date</b></td>
                <td>
                  {' '}
                  {fromDate ? fromDate : '--'} to &nbsp;{toDate ? toDate : '--'}
                </td>
                {/* <td> 31-05-2024 to 31-05-2024</td> */}
                <td><b>Total</b></td>
                <td className="text-center fs-5">
                  {reportData?.reduce((acc: number, item: { bookings_count?: number }) =>
                    acc + (item?.bookings_count ?? 0), 0)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{ 'textAlign': 'center' }}>
                  This is System Generated Report it does not require any signature or stamp.
                </td>
              </tr>
            </tfoot>
          </table>
          {/* <p>Showing 1 to 201 of 201 entries</p> */}
          <div style={{ height: '45px' }}>
            <ReactPaginate
              breakLabel='...'
              nextLabel='next'
              className='dataTables_paginate paging_simple_numbers category'
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              pageCount={pageCount}
              previousLabel='previous'
            // renderOnZeroPageCount={null}
            />
          </div>
        </div>

      </div>
    </div>
  )
}

export default Revenue